export const GET_SCHEMA = "report/api/GET_SCHEMA";
export const ADD_SCHEMA = "report/api/ADD_SCHEMA";
export const GET_REPORT = "report/api/GET_REPORT";
export const ADD_REPORT = "report/api/ADD_REPORT";
export const SUBMIT_FORM = "report/api/SUBMIT_FORM";
export const SUBMIT_FORM_SUCCESS = "report/api/SUBMIT_FORM_SUCCESS";
export const SUBMIT_FORM_FAILURE = "report/api/SUBMIT_FORM_FAILURE";
export const EDIT_REPORT = "report/api/EDIT_REPORT";
export const EDIT_REPORT_SUCCESS = "report/api/EDIT_REPORT_SUCCESS";
export const EDIT_REPORT_FAILURE = "report/api/EDIT_REPORT_FAILURE";

export const FLUSH_REPORT = "report/form/FLUSH_REPORT";
export const EDIT_NAME = "report/format/EDIT_NAME";
export const EDIT_FILENAME = "report/format/EDIT_FILENAME";
export const EDIT_DESCRIPTION = "report/format/EDIT_DESCRIPTION";
export const EDIT_DELIMITER = "report/format/EDIT_DELIMITER";
export const TOGGLE_COMPRESSED = "report/format/TOGGLE_COMPRESSED";
export const EDIT_DURATION = "report/format/EDIT_DURATION";

export const ADD_DIMENSION = "report/structure/ADD_DIMENSION";
export const REMOVE_DIMENSION = "report/structure/REMOVE_DIMENSION";
export const REORDER_DIMENSION = "report/structure/REORDER_DIMENSION";

export const ADD_METRIC = "report/structure/ADD_METRIC";
export const REMOVE_METRIC = "report/structure/REMOVE_METRIC";
export const REORDER_METRIC = "report/Rstructure/REORDER_METRIC";

export const TOGGLE_FTP = "report/endpoint/TOGGLE_FTP";
export const TOGGLE_SFTP = "report/endpoint/TOGGLE_SFTP";
export const TOGGLE_EMAIL = "report/endpoint/TOGGLE_EMAIL";
export const EDIT_ENDPOINT = "report/endpoint/EDIT_ENDPOINT";

export const TOGGLE_DAILY = "report/schedule/TOGGLE_DAILY";
export const TOGGLE_WEEKLY = "report/schedule/TOGGLE_WEEKLY";
export const TOGGLE_MONTHLY = "report/schedule/TOGGLE_MONTHLY";
export const EDIT_DAY = "report/schedule/EDIT_DAY";
export const EDIT_TIME = "report/schedule/EDIT_TIME";
export const EDIT_TIMEZONE = "report/schedule/EDIT_TIMEZONE";
export const EDIT_START = "report/schedule/EDIT_START";
export const TOGGLE_ENABLED = "report/schedule/TOGGLE_ENABLED";

export const EDIT_CONTACTS = "report/contacts/EDIT_CONTACTS";

export const CREATE_REPORT = "report/CREATE_REPORT";

export const editContacts = (contacts) => ({
  type: EDIT_CONTACTS,
  payload: contacts
});

export const createReport = (merchant_id) => ({
  type: CREATE_REPORT,
  payload: { merchant_id }
});

export const editDay = (day) => ({
  type: EDIT_DAY,
  payload: day
});

export const editTimezone = (timezone) => ({
  type: EDIT_TIMEZONE,
  payload: timezone
});

export const editTime = (time) => ({
  type: EDIT_TIME,
  payload: time
});

export const editStart = (day) => ({
  type: EDIT_START,
  payload: day
});

export const toggleDaily = () => ({
  type: TOGGLE_DAILY
});

export const toggleWeekly = () => ({
  type: TOGGLE_WEEKLY
});

export const toggleMonthly = () => ({
  type: TOGGLE_MONTHLY
});

export const toggleSftp = () => ({
  type: TOGGLE_SFTP
});

export const toggleEmail = () => ({
  type: TOGGLE_EMAIL
});

export const toggleFtp = () => ({
  type: TOGGLE_FTP
});

export const editEndpoint = (target, name, value) => ({
  type: EDIT_ENDPOINT,
  payload: { target, name, value }
});

export const getSchema = () => ({
  type: GET_SCHEMA
});

export const addSchema = (schema) => ({
  type: ADD_SCHEMA,
  payload: schema
});

export const getReport = (merchant_id, report_id) => ({
  type: GET_REPORT,
  payload: {
    merchant_id,
    report_id
  }
});

export const addReport = (report) => ({
  type: ADD_REPORT,
  payload: report
});

export const editForm = (merchant_id, report_id, form, sendAfter) => ({
  type: EDIT_REPORT,
  payload: { merchant_id, report_id, form, sendAfter }
});

export const editFormSuccess = (form) => ({
  type: EDIT_REPORT_SUCCESS,
  payload: form
});

export const editFormFailure = (form) => ({
  type: EDIT_REPORT_FAILURE,
  payload: form
});

export const submitForm = (merchant_id, form, sendAfter) => ({
  type: SUBMIT_FORM,
  payload: {
    merchant_id,
    form,
    sendAfter
  }
});

export const submitFormSuccess = (form) => ({
  type: SUBMIT_FORM_SUCCESS,
  payload: form
});

export const submitFormFailure = (form) => ({
  type: SUBMIT_FORM_FAILURE
});

export const flushReport = () => ({
  type: FLUSH_REPORT
});

export const editName = (name) => ({
  type: EDIT_NAME,
  payload: name
});

export const editFilename = (filename) => ({
  type: EDIT_FILENAME,
  payload: filename
});

export const editDescription = (description) => ({
  type: EDIT_DESCRIPTION,
  payload: description
});

export const editDelimiter = (delimiter) => ({
  type: EDIT_DELIMITER,
  payload: delimiter
});

export const toggleCompressed = () => ({
  type: TOGGLE_COMPRESSED
});

export const toggleEnabled = () => ({
  type: TOGGLE_ENABLED
});

export const editDuration = (duration) => ({
  type: EDIT_DURATION,
  payload: duration
});

export const addDimension = (dimension) => ({
  type: ADD_DIMENSION,
  payload: dimension
});

export const removeDimension = (dimension) => ({
  type: REMOVE_DIMENSION,
  payload: dimension
});

export const reorderDimension = (fromIndex, toIndex) => ({
  type: REORDER_DIMENSION,
  payload: {
    fromIndex,
    toIndex
  }
});

export const addMetric = (metric) => ({
  type: ADD_METRIC,
  payload: metric
});

export const removeMetric = (metric) => ({
  type: REMOVE_METRIC,
  payload: metric
});

export const reorderMetric = (fromIndex, toIndex) => ({
  type: REORDER_METRIC,
  payload: {
    fromIndex,
    toIndex
  }
});



// WEBPACK FOOTER //
// ./client/modules/ReportForm/actions.js